import styled from "styled-components";

export const KanbanSectionCounterContainer = styled.div`
  font-size: 1.9rem;
  text-align: end;
`;
